import { post, del } from "../common/apiClient";

const PATH_UPLOAD = "/upload";

// Upload image using multer backend
const uploadImage = async (file) => {
  const formData = new FormData();
  formData.append("image", file);

  return await post(PATH_UPLOAD + "/image", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Upload question image
const uploadQuestionImage = async (file) => {
  const formData = new FormData();
  formData.append("image", file);

  return await post(PATH_UPLOAD + "/image", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

// Delete image
const deleteImage = async (filename) => {
  return await del(PATH_UPLOAD + `/image/${filename}`);
};

const UploadService = {
  uploadImage,
  uploadQuestionImage,
  deleteImage,
};

export default UploadService;
